export const investmentAmounts = [
  // { label: '0 - 25\'000', value: '0 - 25\'000' },
  // { label: '25\'000 - 100\'000', value: '25\'000 - 100\'000' },
  { label: '100\'000 or more', value: '100\'000 or more' }
]
